<template>
  <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
    <div class="card mb-4">
      <div class="card-header">
        <h3 class="mb-0" v-text="title"></h3>
      </div>

      <div class="card-body">
        <h5 class="text-center info-text" v-text="subtitle"></h5>

        <campaign-select
          :key="'previousCampaign' + previousCampaign"
          v-model="campaign"
          :exclude="previousCampaign"
          label="Seleccione la campaña actual"
        />

        <campaign-select
          :key="'campaign' + campaign"
          v-model="previousCampaign"
          :exclude="campaign"
          label="Seleccione la campaña previa"
        />

        <distributor-select
          v-if="$can('index', 'distributors')"
          v-model="distributor"
          :empty-cuit-filter="emptyDistributorCuitFilter"
        />

        <div class="text-right">
          <base-button :disabled="!isSelected" type="primary" @click="generate"> Generar proyecciones </base-button>

          <base-button :disabled="!isSelected" type="neutral" @click="preview">
            Previsualizar Proyecciones
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import DistributorSelect from '@/components/ModelSelects/DistributorSelect';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';

export default {
  components: {
    CampaignSelect,
    DistributorSelect,
  },

  mixins: [CurrentCampaignMixin],
  props: {
    title: {
      type: String,
      default: 'Seleccione las campañas y el distribuidor',
    },

    subtitle: {
      type: String,
      required: true,
    },

    emptyDistributorCuitFilter: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      distributor: null,
      previousCampaign: null,
    };
  },

  computed: {
    isSelected() {
      return (
        this.campaign && this.previousCampaign && this.distributor !== null && this.campaign !== this.previousCampaign
      );
    },
  },

  created() {
    if (this.$auth.user().data.role.name === 'distributor') {
      this.distributor = this.$auth.user().data.roleData.id;
    }
  },

  methods: {
    generate() {
      this.$emit('generate', {
        distributor: this.distributor,
        currentCampaign: this.campaign,
        previousCampaign: this.previousCampaign,
      });
    },

    preview() {
      this.$router.push({
        name: 'ProjectionGeneratePreview',
        params: {
          distributor: this.distributor,
          current_campaign: this.campaign,
          previous_campaign: this.previousCampaign,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  overflow: visible;
}
</style>
